const frequencyFriends = [
    "Muy frecuente",
    "Frecuente",
    "Poco frecuente",
    "Casi nunca",
  ];
  
  export default frequencyFriends;
  